<template>
  <b-modal id="sidebar-chapter" hide-footer scrollable size="lg">
    <template v-slot:modal-header="{ close }">
      <b-link @click="close()" class="back">Back to results <b-img :src="require('@/assets/images/arrow-right.svg')" class="ml-2"></b-img></b-link>
    </template>
    <h4 class="all-categories">All Categories</h4>
    <div v-for="(item, key, i) in chapter" :key="i">
      <category :chap="{item: item, key: key}" />
    </div>
  </b-modal>
</template>
<script>
import Category from '@/components/Category/'
export default {
  computed: {
    chapter () {
      return this.$store.state.chapter
    }
  },
  components: {
    Category
  }
}
</script>

<style lang="scss" scoped>

.all-categories {
  color: $secondary;
  font-weight: 500;
}
.back {
  font-family: $headings-font-family;
  font-weight: 500;
  color: $secondary;
  text-decoration: none;
  img {
    width: 10px;
  }
}
</style>
